import { TIER_LABEL_CHAMPION, TIER_LABEL_POWER, TIER_LABEL_INACTIVE } from '../constants';

export type MemberFilter = 'all' | 'champion' | 'power' | 'inactive';

const TAB_ACTIVE_STYLE: Record<MemberFilter, React.CSSProperties> = {
  all: { backgroundColor: 'var(--anl-accent)', color: '#fff' },
  champion: { backgroundColor: 'var(--anl-warning)', color: '#fff' },
  power: { backgroundColor: 'var(--anl-success)', color: '#fff' },
  inactive: { backgroundColor: 'var(--anl-error)', color: '#fff' },
};

interface MemberFilterTabsProps {
  active: MemberFilter;
  onChange: (tab: MemberFilter) => void;
  counts: { all: number; champion: number; power: number; atRisk: number };
  isLumenaAdmin?: boolean;
}

export function MemberFilterTabs({
  active,
  onChange,
  counts,
  isLumenaAdmin = true,
}: MemberFilterTabsProps) {
  const tabs: { key: MemberFilter; label: string; count: number }[] = [
    { key: 'all', label: 'All Members', count: counts.all },
  ];

  if (isLumenaAdmin) {
    tabs.push(
      { key: 'champion', label: TIER_LABEL_CHAMPION, count: counts.champion },
      { key: 'power', label: TIER_LABEL_POWER, count: counts.power },
      { key: 'inactive', label: TIER_LABEL_INACTIVE, count: counts.atRisk },
    );
  }

  return (
    // overflow-x-auto allows horizontal scroll on mobile when all tabs don't fit
    <div className="mb-4 overflow-x-auto rounded-lg border border-[var(--anl-border)] bg-[var(--anl-surface-elev)] p-1">
      <div className="flex min-w-max gap-1">
        {tabs.map(tab => {
          const isActive = active === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => onChange(tab.key)}
              style={isActive ? TAB_ACTIVE_STYLE[tab.key] : undefined}
              className={`flex flex-shrink-0 items-center justify-center gap-1 rounded-md px-2 py-1 text-xs font-medium transition-all sm:gap-1.5 sm:px-3 sm:py-1.5 sm:text-sm ${
                isActive ? 'shadow-sm' : 'text-[var(--anl-text-muted)] hover:text-[var(--anl-text)]'
              }`}
            >
              {tab.label}
              <span
                className="rounded-full px-1.5 py-0.5 text-xs"
                style={
                  isActive
                    ? { backgroundColor: 'rgba(255,255,255,0.25)', color: '#fff' }
                    : { backgroundColor: 'var(--anl-border)', color: 'var(--anl-text-muted)' }
                }
              >
                {tab.count}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
